<p-dialog [(visible)]="openAttachmentModal" [style]="{width: '35vw'}" (onHide)="closeAttachmentsPopup()" [modal]="true">
    <ng-template pTemplate="header">
       <b> Attachments</b>
    </ng-template>
        <div *ngFor="let attachment of attachmentsData" class="mt-1">
            <em class="blue-color cursor-pointer" (click)="downloadAttachment(attachment.fileId, attachment.attachmentName)"
              ><app-file-icon [fileType]="attachment.attachmentType"></app-file-icon
            ></em>
            <span class="ml-3">{{ attachment.attachmentName }}</span>
          </div>
    <ng-template pTemplate="footer">
    </ng-template>
</p-dialog>
